import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 20,
	viewBox: "0 0 14 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 2.8C2 2.31163 2.36521 2 2.71429 2H11.2857C11.6348 2 12 2.31163 12 2.8V17.2C12 17.6884 11.6348 18 11.2857 18H2.71429C2.36521 18 2 17.6884 2 17.2V2.8ZM2.71429 0C1.16981 0 0 1.30014 0 2.8V17.2C0 18.6999 1.16981 20 2.71429 20H11.2857C12.8302 20 14 18.6999 14 17.2V2.8C14 1.30014 12.8302 0 11.2857 0H2.71429ZM7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17H7.00667C7.55895 17 8.00667 16.5523 8.00667 16C8.00667 15.4477 7.55895 15 7.00667 15H7Z",
		fill: "currentColor"
	})
});
export default SvgMobile;
